import { AddressCreateInput } from '@/__generated__/graphql';
import { Button, Group, Select, Stack, TextInput } from '@mantine/core';
import { isNotEmpty, matches, useForm } from '@mantine/form';

type AddressInput = Pick<
  AddressCreateInput,
  'id' | 'name' | 'streetLine' | 'streetDescription' | 'city' | 'postCode' | 'country' | 'phone'
>;

interface AddressFormProps {
  address?: AddressInput | null;
  onSubmit: (address: AddressInput) => void;
  loading?: boolean;
}

export const AddressForm = ({ address, onSubmit, loading }: AddressFormProps) => {
  const form = useForm<AddressInput>({
    initialValues: {
      id: address?.id,
      name: address?.name ?? '',
      streetLine: address?.streetLine ?? '',
      streetDescription: address?.streetDescription,
      city: address?.city ?? '',
      postCode: address?.postCode ?? '',
      country: address?.country ?? 'SK',
      phone: address?.phone ?? '',
    },
    validate: {
      name: isNotEmpty('Address name is required'),
      streetLine: isNotEmpty('Street is required'),
      city: isNotEmpty('City is required'),
      postCode: matches(/^\d{4,10}$/, 'Invalid ZIP Code'),
      country: isNotEmpty('Country is required'),
      phone: matches(/^\+?[0-9\s-]+$/, 'Invalid phone number'),
    },
  });

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="xs">
        <TextInput label="Name" placeholder="Janko Hrasko" {...form.getInputProps('name')} />
        <TextInput
          label="Street"
          placeholder="123 Main Street"
          {...form.getInputProps('streetLine')}
        />
        <TextInput
          label="Description"
          placeholder="Near the park, 2nd floor, Apartment 4B"
          {...form.getInputProps('streetDescription')}
        />
        <Group grow>
          <TextInput label="City" placeholder="New York" {...form.getInputProps('city')} />
          <TextInput label="ZIP Code" placeholder="10001" {...form.getInputProps('postCode')} />
        </Group>
        <Select
          data={[
            { value: 'SK', label: 'Slovensko' },
            { value: 'CZ', label: 'Česko' },
            { value: 'HU', label: 'Maďarsko' },
            { value: 'AT', label: 'Rakúsko' },
            { value: 'DE', label: 'Nemecko' },
            { value: 'BE', label: 'Belgicko' },
            { value: 'FR', label: 'Francúzsko' },
          ]}
          label="Country"
          placeholder="United states"
          allowDeselect={false}
          {...form.getInputProps('country')}
        />
        <TextInput label="Phone" placeholder="+1 234 567 8900" {...form.getInputProps('phone')} />
        <Button type="submit" fullWidth loading={loading}>
          Uložiť
        </Button>
      </Stack>
    </form>
  );
};
